<script>
import { nanoid } from 'nanoid';
import NextButton from 'dashboard/components-next/button/Button.vue';
import BranchItem from './BranchItem.vue';
import {
  getInputType,
  getOperators,
  getCustomAttributeType,
  showActionInput,
  getDefaultConditions,
  getDefaultActions,
} from 'dashboard/helper/automationHelper';

export default {
  components: {
    NextButton,
    BranchItem,
  },
  props: {
    branches: {
      type: Array,
      default: () => [],
    },
    filterAttributes: {
      type: Array,
      default: () => [],
    },
    actionTypes: {
      type: Array,
      default: () => [],
    },
    getConditionDropdownValues: {
      type: Function,
      default: () => () => [],
    },
    getActionDropdownValues: {
      type: Function,
      default: () => () => [],
    },
    allCustomAttributes: {
      type: Array,
      default: () => [],
    },
    automation: {
      type: Object,
      default: () => ({}),
    },
    automationTypes: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['update:branches'],
  methods: {
    getInputType(key) {
      return getInputType(
        this.allCustomAttributes,
        this.automationTypes,
        this.automation,
        key
      );
    },
    getOperators(key) {
      return getOperators(
        this.allCustomAttributes,
        this.automationTypes,
        this.automation,
        'edit',
        key
      );
    },
    getCustomAttributeType(key) {
      return getCustomAttributeType(this.automationTypes, this.automation, key);
    },
    showActionInput(actionName) {
      return showActionInput(this.actionTypes, actionName);
    },
    addBranch() {
      // Usar la misma lógica que el modo Simple
      const defaultCondition = getDefaultConditions(this.automation.event_name);
      const defaultAction = getDefaultActions();

      const newBranch = {
        id: nanoid(),
        name: `Rama ${this.branches.length + 1}`,
        conditions: defaultCondition,
        actions: defaultAction,
        branches: [],
      };
      const updatedBranches = [...this.branches, newBranch];
      this.$emit('update:branches', updatedBranches);
    },
    updateBranch(index, updatedBranch) {
      const updatedBranches = [...this.branches];
      updatedBranches[index] = updatedBranch;
      this.$emit('update:branches', updatedBranches);
    },
    removeBranch(index) {
      const updatedBranches = this.branches.filter((_, i) => i !== index);
      this.$emit('update:branches', updatedBranches);
    },
  },
};
</script>

<template>
  <div class="branches-editor">
    <!-- Info box explicativo -->
    <div class="mb-4 rounded-md bg-blue-50 p-4 dark:bg-blue-900/20">
      <p class="text-sm text-blue-800 dark:text-blue-200">
        {{ $t('AUTOMATION.BRANCHES.BRANCH_DESCRIPTION') }}
      </p>
    </div>

    <!-- Lista de branches usando componente recursivo -->
    <div v-if="branches.length > 0" class="space-y-4">
      <BranchItem
        v-for="(branch, index) in branches"
        :key="`${branch.id}-${automation.event_name}`"
        :branch="branch"
        :depth="0"
        :filter-attributes="filterAttributes"
        :action-types="actionTypes"
        :get-condition-dropdown-values="getConditionDropdownValues"
        :get-action-dropdown-values="getActionDropdownValues"
        :all-custom-attributes="allCustomAttributes"
        :automation="automation"
        :automation-types="automationTypes"
        @update="updateBranch(index, $event)"
        @remove="removeBranch(index)"
      />
    </div>
    <!-- Botón agregar branch -->
    <NextButton
      icon="i-lucide-plus"
      class="mt-4"
      blue
      :label="$t('AUTOMATION.BRANCHES.ADD_BRANCH')"
      @click="addBranch"
    />
  </div>
</template>

<style scoped>
.branches-editor {
  @apply w-full;
}
</style>
